













import './ValidationErrors.scss'
import { computed, defineComponent } from '@vue/composition-api'
import { ErrorObject } from '@vuelidate/core'
import { useThemes } from '../../compositions'
import { KisweTheme } from '../../types'

export default defineComponent({
  name: 'ValidationErrors',
  props: {
    ...useThemes({ theme: KisweTheme.Danger }).props,
    errors: {
      type: Array as () => ErrorObject[],
      required: true
    },
    oneLine: {
      type: Boolean,
      required: false,
      default: false
    },
    unique: {
      type: Boolean,
      required: false,
      default: false
    },
    showOnlyFirst: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup (props) {
    const computedErrors = computed(() => {
      let localErrors = props.errors.map((item) => item.$message)
      if (props.unique) {
        localErrors = [...new Set(localErrors)]
      }
      if (props.showOnlyFirst) localErrors = localErrors.slice(0,1)
      if (props.oneLine) {
        return [localErrors.join(' / ')]
      } else {
        return localErrors
      }
    })
    return {
      computedErrors
    }
  }
})
